export const config = {
    appName: import.meta.env.VITE_APP_NAME || 'DO Reporting',
    environment: import.meta.env.VITE_APP_ENV || 'development',

    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://dev.portal.dpp.yara.com/api',
    
    authUrl: import.meta.env.VITE_APP_AUTH_URL || 'http://dev.portal.dpp.yara.com/api',
 }